export default 
{
  type: "form-textarea",
  style: "",
  data: {
    label: "New Textarea Field",
    placeholder: "Please Enter",
    rows: 5,
    maxlength: 10000,
    minlength: 0,
  },
  children: [],
};
